export const VNW_BASE_URL = process.env.VNW_BASE_URL
export const CACHE_LIFE_TIME = process.env.CACHE_LIFE_TIME
export const APP_BASE_URL = process.env.APP_BASE_URL
export const IMAGE_BASE_URL = process.env.IMAGE_BASE_URL
export const REQUIRE_IP_CHECK = process.env.REQUIRE_IP_CHECK

export const JOB_SEARCH_LIMIT = 72
export const retrieveFields = [
	'address',
	'jobTitle',
	'isSalaryVisible',
	'companyLogo',
	'userId',
	'jobLevel',
	'jobLevelId',
	'jobLevelVI',
	'jobId',
	'companyId',
	'isAnonymous',
	'alias',
	'workingLocations',
	'companyName',
	'companyId',
	'profilePublishedSiteMask',
	'salaryMin',
	'salaryMax',
	'prettySalary',
	'jobDescription',
	'jobRequirement'
]
export const routeNameMenuIndex = {
	interview: 1,
	salary: 2
}
